<div [class]="skinName">
  <div class="input-container">
    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" name="changePasswordForm" novalidate #changeform="ngForm">
      <div class="form-fields">
        <div class="align-input" [ngClass]="{'has-error':changePasswordForm.controls.old_password.invalid && !changePasswordForm.controls.old_password.pristine }">
          <label class="input-label">{{ configService.localeKeys?.['change_password.current_password.text'] }} </label>
          <div class="input-box-align">
            <input type="password" id="old_password" name="old_password" class="form-control input-box" placeholder="{{ configService.localeKeys?.['change_password.current_password.text']}}" formControlName="old_password" required [type]="oldPasswordType">
            <img [src]="oldPasswordImg" (click)="hidePassword('old_password')">
          </div>
          @if (changePasswordForm.controls.old_password.touched && changePasswordForm.get('old_password').hasError('required') ) {
            <p class="input-placeholder error-block">
            {{ configService.localeKeys?.['change_password.old_password_required.text']}}</p>
          }
        </div>


        <div class="align-input" [ngClass]="{'has-error':changePasswordForm.controls.password.invalid && !changePasswordForm.controls.password.pristine }">
          <label class="input-label">{{ configService.localeKeys?.['change_password.new_password.text'] }} </label>
          <div class="input-box-align">
            <input type="password" id="password" name="password" class="form-control input-box" placeholder="{{ configService.localeKeys?.['change_password.new_password.text']}}" formControlName="password" required [type]="passwordType">
            <img [src]="passwordImg" (click)="hidePassword('password')">
          </div>
          @if (changePasswordForm.controls.password.touched && changePasswordForm.get('password').hasError('required') ) {
            <p class="input-placeholder error-block">
            {{ configService.localeKeys?.['common_keys.password_reqd.text']}}</p>
          }
          @if (changePasswordForm.controls.password.dirty && !changePasswordForm.get('password').hasError('required') && changePasswordForm.get('password').hasError('minlength')) {
            <p class="input-placeholder error-block">
            {{ configService.localeKeys?.['common_keys.new_password_min_length.text']}}</p>
          }
        </div>

        <div class="align-input" [ngClass]="{'has-error':(changePasswordForm.controls.password_confirmation.dirty && changePasswordForm.controls.password_confirmation.invalid) || (!changePasswordForm.controls.password_confirmation.pristine && changePasswordForm.get('password').value != changePasswordForm.get('password_confirmation').value)}">
          <label class="input-label">{{ configService.localeKeys?.['change_password.confirm_new_password.text'] }} </label>
          <div class="input-box-align">
            <input type="password" id="password_confirmation" name="password_confirmation" class="form-control input-box" placeholder="{{ configService.localeKeys?.['change_password.confirm_new_password.text']}}" formControlName="password_confirmation" required [type]="confirmPasswordType">
            <img [src]="confirmPasswordImg" (click)="hidePassword('password_confirmation')">
          </div>
          @if (changePasswordForm.controls.password_confirmation.touched && changePasswordForm.get('password_confirmation').hasError('required') ) {
            <p class="input-placeholder error-block">
            {{ configService.localeKeys?.['change_password.confirm_password_reqd.text']}}</p>
          }
          @if (!changePasswordForm.get('password_confirmation').hasError('required') && changePasswordForm.get('password').value != changePasswordForm.get('password_confirmation').value) {
            <p class="input-placeholder error-block">
            {{ configService.localeKeys?.['common_keys.password_not_matching.text']}}</p>
          }
          @if (changePasswordForm.controls.password_confirmation.dirty && !changePasswordForm.get('password_confirmation').hasError('required') && changePasswordForm.get('password_confirmation').hasError('minlength') && changePasswordForm.get('password').value == changePasswordForm.get('password_confirmation').value) {
            <p class="input-placeholder error-block">
            {{ configService.localeKeys?.['common_keys.new_password_min_length.text']}}</p>
          }
        </div>
      </div>
      <div>
        <button type="submit" [disabled]="(baseService.disableBuuton | async)" class="uk-button submit-btn">{{ configService.localeKeys?.cng_pass_btn_save_cng_def}}</button>
      </div>
    </form>
  </div>

</div>